'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ToolTipText = require('./ToolTipText');

var _ToolTipText2 = _interopRequireDefault(_ToolTipText);

var _ToolTipTSpanLabel = require('./ToolTipTSpanLabel');

var _ToolTipTSpanLabel2 = _interopRequireDefault(_ToolTipTSpanLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OHLCTooltipDisplayFactory = function OHLCTooltipDisplayFactory(determineColor) {
  return function (props, moreProps, itemsToDisplay) {
    var className = props.className,
        labelFill = props.labelFill,
        onClick = props.onClick,
        fontFamily = props.fontFamily,
        fontSize = props.fontSize;
    var displayDate = itemsToDisplay.displayDate,
        open = itemsToDisplay.open,
        high = itemsToDisplay.high,
        low = itemsToDisplay.low,
        close = itemsToDisplay.close,
        volume = itemsToDisplay.volume,
        x = itemsToDisplay.x,
        y = itemsToDisplay.y;


    var displayTexts = {
      d: 'D: ',
      o: ' O: ',
      h: ' H: ',
      l: ' L: ',
      c: ' C: ',
      v: ' V: ',
      na: 'n/a'
    };

    var textFill = determineColor({ open: open, high: high, low: low, close: close });

    if (displayDate == 'n/a') return null;

    return _react2.default.createElement(
      'g',
      {
        className: 'react-stockcharts-tooltip-hover ' + className,
        transform: 'translate(' + x + ', ' + y + ')',
        onClick: onClick },
      _react2.default.createElement(
        _ToolTipText2.default,
        {
          x: 0,
          y: 0,
          fontFamily: fontFamily,
          fontSize: fontSize },
        _react2.default.createElement(
          _ToolTipTSpanLabel2.default,
          {
            fill: labelFill,
            key: 'label',
            x: 0,
            dy: '5' },
          displayTexts.d
        ),
        _react2.default.createElement(
          'tspan',
          { key: 'value', fill: textFill },
          displayDate
        ),
        _react2.default.createElement(
          _ToolTipTSpanLabel2.default,
          { fill: labelFill, key: 'label_O' },
          displayTexts.o
        ),
        _react2.default.createElement(
          'tspan',
          { key: 'value_O', fill: textFill },
          open
        ),
        _react2.default.createElement(
          _ToolTipTSpanLabel2.default,
          { fill: labelFill, key: 'label_H' },
          displayTexts.h
        ),
        _react2.default.createElement(
          'tspan',
          { key: 'value_H', fill: textFill },
          high
        ),
        _react2.default.createElement(
          _ToolTipTSpanLabel2.default,
          { fill: labelFill, key: 'label_L' },
          displayTexts.l
        ),
        _react2.default.createElement(
          'tspan',
          { key: 'value_L', fill: textFill },
          low
        ),
        _react2.default.createElement(
          _ToolTipTSpanLabel2.default,
          { fill: labelFill, key: 'label_C' },
          displayTexts.c
        ),
        _react2.default.createElement(
          'tspan',
          { key: 'value_C', fill: textFill },
          close
        ),
        _react2.default.createElement(
          _ToolTipTSpanLabel2.default,
          { fill: labelFill, key: 'label_Vol' },
          displayTexts.v
        ),
        _react2.default.createElement(
          'tspan',
          { key: 'value_Vol', fill: textFill },
          volume
        )
      )
    );
  };
};

exports.default = OHLCTooltipDisplayFactory;
//# sourceMappingURL=OHLCTooltipDisplayFactory.js.map